import React from "react";

const OnTimeMinMS = 1000;
const OnTimeMaxMS = 3000;

const OffTimeMS = 500;

interface IProps {
    readonly r: number;
    readonly g: number;
    readonly b: number;
}

function getOnTime(): number {
    return OnTimeMinMS + (Math.random() * (OnTimeMaxMS - OnTimeMinMS));
}

function PantyBlinkerBase(props: React.PropsWithChildren<IProps>): React.ReactElement {
    const [show, setShow] = React.useState(true);

    React.useEffect(() => {
        function turnOn() {
            setShow(true);
            setTimeout(turnOff, getOnTime());
        }

        function turnOff() {
            setShow(false);
            setTimeout(turnOn, OffTimeMS);
        }

        setTimeout(turnOff, getOnTime());
    },
    []);

    const a = show ? 1 : 0;
    const style: React.CSSProperties = {
        color: `rgba(${props.r}, ${props.g}, ${props.b}, ${a})`,
        fontWeight: "bold",
        fontSize: "x-large"
    };

    return <span style={style}>PANTIES</span>;
}

export const PantyBlinker = React.memo(PantyBlinkerBase);